<script setup>
  import {
    nextTick,
    onMounted,
    ref,
  } from 'vue'

  import Article from './Article.vue'
  import Loading from '@components/Loading.vue'
  import Pagination from '@components/Pagination.vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import { pageTop } from '@shared/util.js'

  const articles = ref(null)
  const page = ref(1)
  const current = ref([])

  const per = 16

  const { vt } = useI18n('welcome.index.js')
  const { callGet } = useAjax()

  onMounted(() => {
    getArticles()
  })

  /**
   * ページ移動
   */
  const handleMovePage = (value) => refresh()

  /**
   * ブログ情報の取得（全体）
   */
  const getArticles = async () => {
    const url = new URL(location.href)
    url.pathname = `${url.pathname.replace(/\/$/, '')}.json`
    url.searchParams.append('no_content', 't')
    const response = await callGet(url.toString())

    if (response.articles && response.articles.length > 0) {
      articles.value = response.articles
      refresh()
    }
    else {
      articles.value = []
    }
  }

  /**
   * 物件一覧の表示
   * 表示対象のページの物件情報をajaxで取得する
   */
  const refresh = () => {
    const target = articles.value.slice(per * (page.value - 1), per * page.value)
    pageTop(100)
    Promise.allSettled(target.map((article) => callGet(article.path)))
      .then((results) => {
        current.value = results.filter((result) => result.status == 'fulfilled').map((result) => result.value.article)
      })
  }
</script>

<template>
  <template v-if="articles">
    <div class="blog_menu">
      <div class="blog_list">
        <Article v-for="article in current" :key="`article-${article.path}`" :article="article" />
      </div>
    </div>

    <Pagination v-model="page" :per="per" :total="articles.length" @move="handleMovePage" />
  </template>
  <template v-else>
    <Loading style="margin-top: 100px;" />
  </template>
</template>

<style>
  .blog_listing .blog_list .item .photo img {
    max-height: 282px;
  }
</style>
